import { render, staticRenderFns } from "./InfoTooltip.vue?vue&type=template&id=dea1f836&"
import script from "./InfoTooltip.vue?vue&type=script&lang=js&"
export * from "./InfoTooltip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports